import { computed } from 'vue'

import {
  ACCESS_LEVEL_PERMISSION,
} from './const'

import rules from './rules'
import type { PermissionOverrides, Rule, RuleParams } from './types'

import { useCore } from '@/composables/core/index'
import { useEppo } from '@/composables/eppo/index'

export type { PermissionOverrides, Rule, RuleParams }
export type AccessLevelPermissionType = typeof ACCESS_LEVEL_PERMISSION[keyof typeof ACCESS_LEVEL_PERMISSION]

type Store = {
  getters: Record<string, unknown>
  state: {
    business?: {
      business?: {
        current_staffer?: {
          permission_overrides?: PermissionOverrides | null
        }
      }
    }
  }
}

export type UseAccessLevelPermissionsResult = {
  ACCESS_LEVEL_PERMISSION: typeof ACCESS_LEVEL_PERMISSION
  hasAccess: (permission: AccessLevelPermissionType) => boolean
}

export const useAccessLevelPermissions = (): UseAccessLevelPermissionsResult => {
  const { store } = useCore()
  const eppo = useEppo()

  const typedStore = store as Store
  const loggedUserAccessLevel = computed(() => typedStore.getters['identity/userAccessLevel'] as string | undefined)
  const loggedUserPermissionOverrides = computed(() => typedStore.state.business?.business?.current_staffer?.permission_overrides)

  const hasAccess = (permission: AccessLevelPermissionType): boolean => {
    const accessRules = rules as Record<AccessLevelPermissionType, Rule>
    const rule = accessRules[permission]
    if (!rule) return false
    return rule({
      accessLevel: loggedUserAccessLevel.value,
      overrides: loggedUserPermissionOverrides.value,
      ff: eppo.ff,
    })
  }

  return {
    ACCESS_LEVEL_PERMISSION,
    hasAccess,
  }
}
